/* kns-steel-periodic.js — Periodic Table of Knife Steel
   Vanilla IIFE, no dependencies, defer-loaded.
   CSS contract: .is-selected, .is-docked, .kns-pt__explain-close
   Authored for Task 12 of the periodic-table feature branch. */
(function () {
  'use strict';

  var dataEl = document.getElementById('kns-steel-elements-data');
  var grid   = document.getElementById('kns-pt-grid');
  var explain = document.getElementById('kns-pt-explain');
  if (!dataEl || !grid || !explain) return;

  var model;
  try { model = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var els = model && Array.isArray(model.elements) ? model.elements : null;
  if (!els || !els.length) return;
  var mq = window.matchMedia('(max-width: 640px)');

  /* ─── Build cells ─────────────────────────────────────── */
  els.forEach(function (el) {
    var actionable = el.tier === 'signal' || el.tier === 'trace';
    var cell = document.createElement(actionable ? 'button' : 'div');
    cell.className = 'kns-pt__cell';
    cell.setAttribute('role', 'gridcell');
    cell.setAttribute('data-tier', el.tier);
    cell.setAttribute('data-symbol', el.symbol);
    cell.style.setProperty('--x', el.xpos);
    cell.style.setProperty('--y', el.ypos);
    cell.tabIndex = -1;
    if (actionable) {
      cell.type = 'button';
      cell.setAttribute('aria-expanded', 'false');
      cell.setAttribute('aria-controls', 'kns-pt-explain');
      cell.setAttribute('aria-label', el.name + ' (' + el.symbol + '), atomic number ' + el.z);
    } else {
      cell.setAttribute('aria-label', el.name + ', atomic number ' + el.z + ' — not relevant to blade steel');
    }
    /* textContent (not innerHTML) so model values can never inject markup */
    var numEl = document.createElement('span');
    numEl.className = 'kns-pt__num';
    numEl.textContent = el.z;
    var symEl = document.createElement('span');
    symEl.className = 'kns-pt__sym';
    symEl.textContent = el.symbol;
    cell.appendChild(numEl);
    cell.appendChild(symEl);
    grid.appendChild(cell);
  });
  grid.hidden = false;

  /* ─── Roving-tabindex setup ────────────────────────────── */
  var cells = Array.prototype.slice.call(grid.children);

  /* Build a position lookup: "xpos,ypos" → index in cells array */
  var byPos = {};
  cells.forEach(function (c, i) {
    var key = c.style.getPropertyValue('--x') + ',' + c.style.getPropertyValue('--y');
    byPos[key] = i;
  });

  /* Start roving focus on the first signal cell */
  var current = -1;
  cells.forEach(function (c, i) {
    if (current < 0 && c.getAttribute('data-tier') === 'signal') current = i;
  });
  if (current < 0) current = 0;
  cells[current].tabIndex = 0;

  function setCurrent(i) {
    cells[current].tabIndex = -1;
    current = i;
    cells[i].tabIndex = 0;
    cells[i].focus();
  }

  /* 2-D spatial walk: steps up to 18 columns / 10 rows to skip gaps */
  function move(dx, dy) {
    var x = +cells[current].style.getPropertyValue('--x');
    var y = +cells[current].style.getPropertyValue('--y');
    for (var step = 1; step <= 18; step++) {
      var key = (x + dx * step) + ',' + (y + dy * step);
      if (key in byPos) { setCurrent(byPos[key]); return; }
    }
  }

  /* ─── Keyboard navigation ──────────────────────────────── */
  grid.addEventListener('keydown', function (e) {
    switch (e.key) {
      case 'ArrowRight': move(1,  0); e.preventDefault(); break;
      case 'ArrowLeft':  move(-1, 0); e.preventDefault(); break;
      case 'ArrowDown':  move(0,  1); e.preventDefault(); break;
      case 'ArrowUp':    move(0, -1); e.preventDefault(); break;
      case 'Enter':
      case ' ':
        var c = cells[current];
        if (c.tagName === 'BUTTON') {
          if (openCell === c) { closeExplain(); } else { openExplain(c.getAttribute('data-symbol'), c); }
          e.preventDefault();
        }
        break;
      case 'Escape':
        closeExplain();
        break;
    }
  });

  /* ─── Explain panel state ──────────────────────────────── */
  var openCell = null;

  function openExplain(symbol, cell) {
    /* Source: canonical list section #el-<symbol> */
    var source = document.getElementById('el-' + symbol);
    if (!source) { if (openCell && openCell !== cell) closeExplain(); return; }

    /* Clone content into the panel */
    explain.innerHTML = source.innerHTML;

    /* Inject close button as first child */
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kns-pt__explain-close';
    btn.setAttribute('aria-label', 'Close');
    btn.textContent = '×'; /* × */
    btn.addEventListener('click', closeExplain);
    explain.insertBefore(btn, explain.firstChild);

    /* Reveal panel */
    explain.hidden = false;

    /* Toggle .is-selected */
    if (openCell) {
      openCell.classList.remove('is-selected');
      openCell.setAttribute('aria-expanded', 'false');
    }
    cell.classList.add('is-selected');
    cell.setAttribute('aria-expanded', 'true');
    openCell = cell;

    /* Position: mobile dock vs desktop float */
    if (mq.matches) {
      /* Mobile: CSS media query handles fixed dock; add class for JS-driven dock too */
      explain.style.top  = '';
      explain.style.left = '';
      explain.classList.add('is-docked');
    } else {
      explain.classList.remove('is-docked');
      explain.style.top  = '';
      explain.style.left = '';

      /* Panel is position:fixed → viewport coords, kept fully on-screen. */
      var cellRect    = cell.getBoundingClientRect();
      var panelWidth  = explain.offsetWidth  || 360;
      var panelHeight = explain.offsetHeight || 420;
      var margin      = 12;

      /* Preferred: below the cell; flip above if it would clip the bottom */
      var top = cellRect.bottom + 8;
      if (top + panelHeight > window.innerHeight - margin) {
        top = cellRect.top - panelHeight - 8;
      }
      /* Final vertical clamp so it is always fully visible */
      if (top < margin) top = margin;
      if (top + panelHeight > window.innerHeight - margin) {
        top = Math.max(margin, window.innerHeight - margin - panelHeight);
      }

      /* Align to the cell's left edge, clamp within the viewport */
      var left = cellRect.left;
      var maxLeft = window.innerWidth - panelWidth - margin;
      if (left > maxLeft) left = maxLeft;
      if (left < margin) left = margin;

      explain.style.top  = top  + 'px';
      explain.style.left = left + 'px';
    }

    /* Focus management: move into panel so keyboard users land in dialog */
    btn.focus();
  }

  function closeExplain() {
    explain.hidden = true;
    explain.innerHTML = '';
    explain.classList.remove('is-docked');
    explain.style.top  = '';
    explain.style.left = '';
    if (openCell) {
      openCell.setAttribute('aria-expanded', 'false');
      openCell.classList.remove('is-selected');
      openCell.focus();
      openCell = null;
    }
  }

  /* Escape closes the panel when focus is inside it. On open, focus moves to
     the close button — a sibling of the grid — so the grid's Escape handler
     never sees the keydown. This handler covers focus-in-panel. */
  explain.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { e.preventDefault(); closeExplain(); }
  });

  /* ─── Click handlers ───────────────────────────────────── */
  cells.forEach(function (c) {
    if (c.tagName !== 'BUTTON') return;
    c.addEventListener('click', function () {
      if (openCell === c) { closeExplain(); } else { openExplain(c.getAttribute('data-symbol'), c); }
    });
  });

  /* Click-outside-to-close */
  document.addEventListener('click', function (e) {
    if (openCell &&
        !e.target.closest('#kns-pt-explain') &&
        !e.target.closest('.kns-pt__cell')) {
      closeExplain();
    }
  });

  /* ─── Reposition / teardown on resize ──────────────────── */
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (openCell) closeExplain();
    }, 100);
  });

  /* Also handle mq breakpoint flip explicitly */
  var mqListener = function () {
    if (openCell) closeExplain();
  };
  if (mq.addEventListener) {
    mq.addEventListener('change', mqListener);
  } else if (mq.addListener) {
    /* Safari <14 fallback */
    mq.addListener(mqListener);
  }

})();
